import React from 'react';
import LoginForm from '../../Shared/LoginForm';

function Signin() {
  return <LoginForm />;
}

export default Signin;
